<template>
    <div class="vsector__counts">
        <span class="subheading">In Numbers</span>
        <dl class="counts" v-if="counts">
            <div class="counts__item count">
                <dt>Opportunities</dt>
                <dd>
                    <router-link :to="`/opportunities?sectors=${sectorId}`">
                        <span>{{ counts.opportunities }}</span>
                        <sup>
                            <SvgIcon icon="ex-link" :is-filled="true" style="width: 1.4rem; height: 1.4rem; margin-left: -0.4rem;"/>
                        </sup>
                    </router-link>
                </dd>
            </div>
            <div class="counts__item count">
                <dt>MADDs</dt>
                <dd>
                    <router-link :to="`/madds?sectors=${sectorId}`">
                        <span>{{ counts.madds }}</span>
                        <sup>
                            <SvgIcon icon="ex-link" :is-filled="true" style="width: 1.4rem; height: 1.4rem; margin-left: -0.4rem;"/>
                        </sup>
                    </router-link>
                </dd>
            </div>
            <div class="counts__item count">
                <dt>Documents</dt>
                <dd>
                    <router-link :to="documentLink">
                        <span>{{ counts.insights }}</span>
                        <sup>
                            <SvgIcon icon="ex-link" :is-filled="true" style="width: 1.4rem; height: 1.4rem; margin-left: -0.4rem;"/>
                        </sup>
                    </router-link>
                </dd>
            </div>
            <div class="counts__item count">
                <dt>Experts</dt>
                <dd>
                    <router-link :to="`/sectors/${sectorId}/experts`">
                        <span>{{ counts.experts }}</span>
                        <sup>
                            <SvgIcon icon="ex-link" :is-filled="true" style="width: 1.4rem; height: 1.4rem; margin-left: -0.4rem;"/>
                        </sup>
                    </router-link>
                </dd>
            </div>
        </dl>
    </div>
</template>
<script>
import API from '@api';
import SvgIcon from '@components/SvgIcon';

export default {
    name: 'SectorCounts',
    components: {
        SvgIcon,
    },
    props: {
        sectorId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            isLoading: true,
            counts: null,
        }
    },
    methods: {
        async getCounts() {
            try {
                this.isLoading = true;
                this.counts = await API.getSectorCounts(this.sectorId);
            } catch(err) {
                console.warn(`[Counts.vue] ${ err.message }`);
            } finally {
                this.isLoading = false;
            }
        },
    },
    computed: {
        documentLink() {
            if (this.counts && this.counts.insightCategory) {
                return `/documents/category/${this.counts.insightCategory.id}`;
            }

            return `/documents/list?sectors=${this.sectorId}`;
        },
    },
    watch: {
        sectorId() {
            this.getCounts();
        },
    },
    created() {
        this.getCounts();
    },
}
</script>
<style lang="scss" scoped>
@import '~@/theme/_variables.scss';

.subheading {
    color: #232D37;
    display: block;
    font-size: 1.8rem;
    line-height: 2.3rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
}

.count {
    margin: 0;

    dt {
        color: #657787;
        font-size: 1.5rem;
        letter-spacing: 0.054rem;
        line-height: 1.8rem;
        margin-bottom: .4rem;
    }

    dd {
        color: $link;
        font-size: 2rem;
        line-height: 2.4rem;
        font-weight: 500;
        margin-left: 0;
    }
}

.counts {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 1rem;

    .counts__item {
        flex: 0 0 calc(50% - 1rem);
    }
}
</style>
